import { gql } from '@apollo/client';

export const GET_ORDERBOOK = gql`
    query customerOrderbook {
        customerOrderbook {
        __typename
            orders{
                __typename
                items {
                    __typename
                    id
                    number
                    order_date
                    shipping_address {
                        firstname
                        lastname
                        city
                        street
                        country_code
                        telephone
                        company
                        vat_id
                    }
                    billing_address {
                        firstname
                        lastname
                        city
                        street
                        country_code
                        telephone
                        company
                        vat_id
                    }
                    total {
                        subtotal{
                            value
                        }
                        discounts{
                            amount{
                                value
                            }
                        }
                        taxes {
                            amount {
                                value
                            }
                        }
                        total_shipping {
                            value
                        }
                        grand_total {
                            currency
                            value
                        }
                    }
                    status
                    shipments{
                        id
                        items{
                            __typename
                            id
                            product_name
                            product_sku
                            quantity_shipped
                        }
                    }
                    credit_memos {
                        __typename
                        id
                        total {
                            subtotal{
                                value
                            }
                            adjustment {
                                value
                            }
                            grand_total {
                                value
                            }
                            total_tax{
                                value
                            }
                        }
                        items {
                            __typename
                            product_name
                            product_sku
                            quantity_refunded
                            product_sale_price {
                                value
                            }
                            discounts {
                                amount {
                                    value
                                }
                            }
                        }
                    }
                    invoices {
                        __typename
                        total{
                            subtotal{
                                value
                            }
                            discounts{
                                label
                                amount{
                                    value
                                }
                            }
                            grand_total{
                                value
                            }
                            taxes{
                                amount{
                                    value
                                }
                            }
                            shipping_handling{
                                amount_including_tax{
                                    value
                                }
                            }
                        }
                        items {
                            __typename
                            id
                            product_name
                            product_sku
                            product_sale_price{
                                value
                            }
                            quantity_invoiced
                            discounts {
                                label
                                amount{
                                    value
                                }
                            }
                        }
                    }
                    items {
                        __typename
                        product_name
                        product_sku
                        status
                        advanced_product_inventory {
                            priceWithoutRounding
                            is_qty_decimal
                            unit
                        }
                        quantity_ordered
                        quantity_canceled
                        quantity_refunded
                        quantity_shipped
                        quantity_returned
                        product_sale_price {
                            value
                        }
                    }
                    gift_wrapping {
                        price {
                            currency
                            value
                        }
                    }
                    shipping_method
                    payment_methods {
                        name
                        type
                    }
                }
            }
        }
  }
`;